import { AfterViewInit, Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { CustomerForm } from './customer.form';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractFormComponent } from '../../../../../shared/crud/component/form.component';
import { AdminUrlBuilder } from '../../../../../shared/admin/api/admin-url-builder';
import { ISelectOption } from '../../../../../shared/form/element/base-select/select-option.interface';

@Component({
  selector: 'admin-customer-form',
  templateUrl: './form.component.html',
  styleUrls: [ './form.component.scss' ]
})
export class AdminCustomerFormComponent extends AbstractFormComponent implements OnInit, AfterViewInit {

  blockOptions: ISelectOption[] = [
    {
      value: true,
      label: 'yes'
    },
    {
      value: false,
      label: 'no'
    }
  ];
  owner: any = {};

  constructor(formBuilder: CustomerForm,
              httpClient: HttpClient,
              toastrService: ToastrService,
              router: Router,
              urlBuilder: AdminUrlBuilder,
              route: ActivatedRoute) {
    super(formBuilder, httpClient, toastrService, router, route, urlBuilder);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.formMode = 'update';

    this.populate().subscribe();

    this.httpClient.get(`${this.urlBuilder.buildUrl(this.getUrl())}/owner`).subscribe((response: any) => {
      this.owner = response;
      this.form.patchValue({
        firstName: response.firstName,
        lastName: response.lastName
      });
    });
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();

  }

  protected getUrl(): string {
    return `/customer${this.route.parent.snapshot.params.id ? '/' + this.route.parent.snapshot.params.id : ''}`;
  }

  protected onSubmit(response: any): void {
    this.toastrService.success('Saved');
  }

  reset() {
    this.populate().subscribe();
  }
}
